import React, { Component } from 'react';
import dbAbout from '../assets/dbAbout.gif';
import * as FaIconPack from 'react-icons/lib/fa';
import resume from '../assets/DanBeerman-Resume.pdf';
import {
  OutboundLink
} from 'gatsby-plugin-google-analytics';
class About extends Component {
  render() {
    return <div className="About section">
        <div className="about-content">
          <h1 className="about-intro">
            I'm about <strong>tech + community + making things</strong>.
          </h1>
          <p className="about-item">
            <strong>I love to work with great people. </strong> I enjoy creating with a passion and a purpose.
            It's easy for me to get excited about learning. And I'm always happy to connect with new people. 
          </p>
          <p className="about-item">
            Currently, I'm based out of Denver, CO.<br />
          </p>
          <p className="about-item">
            Originally, I'm from Missouri. I went to the University of Missouri and earned a BS in
            Biochemistry. I've worked as a technical writer, water researcher, outdoor educator, backpacking/climbing 
            guide, bartender, events organizer, community manager, and illustrator. 
            Now I write code.
          </p>
        </div>
        <div className="about-content">
          <img src={dbAbout} className="profile" />
          <OutboundLink href = {resume} target = "_blank" rel = "noopener noreferrer" >
            <button className="button i-hov">
              <FaIconPack.FaFilePdfO size={30} aria-hidden="true" /> Resume
            </button>
          </ OutboundLink >
        </div>
      </div>
  }
}
export default About;



// WEBPACK FOOTER //
// ./src/pages/About.js